import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

const embedSearchWidgetRouteGroup = new AppRouteGroup(
  '/embed-search-widget/:embedSearchWidgetId',
);

// Volops

const embedSearchWidgetVolopsRouteGroup =
  embedSearchWidgetRouteGroup.subgroup('volops');

export const embedSearchWidgetSearchVolopsRoute =
  embedSearchWidgetVolopsRouteGroup.rootRoute([
    'areasOfFocus',
    'functions',
    'locationType',
    'locale',
    'radius',
    'recency',
    'source',
    'startsLT',
    'endsGT',
    'q',
    'page',
    'sort',
  ]);

export const embedSearchWidgetViewVolopRoute =
  embedSearchWidgetVolopsRouteGroup.route(':volopId');

export const embedSearchWidgetApplyToVolopRoute =
  embedSearchWidgetVolopsRouteGroup.route(':volopId/apply');
